import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Image, Typography, Radio } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { InputRadio, InputField, TextAreaField, DateField, SelectField } from '../../../../../atoms/FormElement';
import { getExpenditureDropdownData } from '../../ducks/actions';
import { EXPENDITURE_PURPOSE_CODE, FORMS_OF_PAYMENTS } from '../../../../../../configs/constants';
import { getContactFormData } from '../../../Contacts/ducks/actions';

const { Paragraph } = Typography;

export default (props) => {
  const {
    control,
    errors,
    formData,
    setValue,
    setLoading,
    remainingAmount,
    setRemainingAmount,
    setOldAmount,
    oldAmount,
    setError,
    watch,
    clearErrors,
  } = props;
  const dispatch = useDispatch();
  const [formOfPayment, setFormOfPayment] = useState('');
  const [purposeCode, setPurposeCode] = useState(false);
  const [contactBoxEditCase, setContactBoxEditCase] = useState('');
  const [contactToSelect, setContactToSelect] = useState(null);
  const receiptFormData = useSelector((state) => state.expenditure.expenditureDropData);
  let contributerData = useSelector((state) => state.contact.contactFormData);
  const amountPaid = watch('amount');

  useEffect(() => {
    if (remainingAmount && amountPaid) {
      const mainAmount = oldAmount + remainingAmount;

      if (Math.round((+amountPaid + Number.EPSILON) * 100) / 100 > mainAmount) {
        setError('amount', {
          type: 'required',
          message: 'Please enter an amount that does not exceed the remaining debt balance.',
        });
        return;
      } else {
        clearErrors('amount');
      }
    }
  }, [amountPaid, remainingAmount]);

  useEffect(() => {
    dispatch(getExpenditureDropdownData('debt_repayment', 'null'));
  }, []);

  useEffect(() => {
    if (
      formData?.expenditureData &&
      Object.keys(receiptFormData)?.length > 0 &&
      Object.keys(formData?.expenditureData)?.length > 0
    ) {
      const selectedAccountList = receiptFormData?.accounts?.find(
        (e) => e?.value == formData?.expenditureData?.account_id,
      );
      const selectedPayeeList = receiptFormData?.contributors?.find(
        (e) => e?.value == (contactToSelect ? contactToSelect : formData?.expenditureData?.payee_id),
      );
      let selectedReimburseList = [];
      formData?.expenditureData?.purpose_code?.length > 0 &&
        formData?.expenditureData?.purpose_code?.map((x) => {
          selectedReimburseList.push({
            label: EXPENDITURE_PURPOSE_CODE?.find((y) => y?.value == x)?.label,
            value: x,
          });
        });

      const selectedObligationID = receiptFormData?.obligations?.find(
        (e) => e?.value == formData.expenditureData?.obligation_id,
      );

      if (selectedObligationID) {
        setRemainingAmount(selectedObligationID?.amounRemaining);
      }

      if (formData.expenditureData?.amount) {
        setOldAmount(formData.expenditureData?.amount);
      }

      setLoading(true);
      setValue('amount', formData.expenditureData?.amount);
      setValue('obligation_id', selectedObligationID);
      setValue('date', formData?.expenditureData?.date ? moment(formData?.expenditureData?.date, 'YYYY-MM-DD') : '');
      setValue('payee_id', selectedPayeeList);
      setValue('purpose_code', selectedReimburseList);
      setValue('comments', formData.expenditureData?.comments);
      setValue('payment_type', formData.expenditureData?.payment_type);
      setFormOfPayment(formData.expenditureData?.payment_type);
      setContactToSelect(null);
      setTimeout(() => {
        setContactBoxEditCase(selectedPayeeList);
        setValue('check_number', formData.expenditureData?.check_number);
        setValue('in_kind_description', formData.expenditureData?.in_kind_description);
        setValue('account', selectedAccountList);
        setValue('remarks', formData.expenditureData?.remarks);
        purposeSelection(selectedReimburseList);
      }, 1000);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [receiptFormData, formData]);

  const purposeSelection = (e) => {
    if (
      e.some(
        (resp) =>
          resp.value === 'A' ||
          resp.value === 'B' ||
          resp.value === 'C' ||
          resp.value === 'F' ||
          resp.value === 'H' ||
          resp.value === 'K' ||
          resp.value === 'O',
      )
    ) {
      setPurposeCode(true);
    } else {
      setPurposeCode(false);
    }
  };

  const changeValueByDropDown = (e) => {
    dispatch(getContactFormData(e));
  };

  const updateDropdownValues = () => {
    dispatch(getExpenditureDropdownData('operating-expense', 'null'));
  };

  const formPayment = (e) => {
    setFormOfPayment(e.target.value);

    if (receiptFormData && receiptFormData?.accounts?.length == 1) {
      setTimeout(() => {
        setValue('account', receiptFormData?.accounts[0]);
      }, 500);
    }
  };

  const getObligationValue = (e) => {
    setRemainingAmount(e?.amounRemaining);
  };

  //console.log('remainingAmount', remainingAmount);

  return (
    <>
      <Row gutter={[48, 30]}>
        <Col span={12}>
          <Row gutter={[12, 30]}>
            <Col span={24}>
              <SelectField
                isRequired={true}
                fieldname="obligation_id"
                label="Debt That Committee Repaid"
                control={control}
                initValue=""
                onChange={getObligationValue}
                iProps={{
                  size: 'large',
                  placeholder: 'Please select',
                }}
                rules={{
                  required: 'Debt That Committee Repaid is required.',
                }}
                selectOption={receiptFormData?.obligations}
                validate={errors.obligation_id && 'error'}
                validMessage={errors.obligation_id && errors.obligation_id.message}
              />
            </Col>

            <Col span={24}>
              <InputField
                isRequired={true}
                fieldname="amount"
                label="Amount Repaid"
                control={control}
                initValue=""
                iProps={{
                  size: 'large',
                  prefix: '$',
                  type: 'number',
                }}
                rules={{
                  required: 'Amount Repaid is required.',
                }}
                validate={errors.amount && 'error'}
                validMessage={errors.amount && errors.amount.message}
              />
            </Col>

            <Col span={24}>
              <DateField
                fieldname="date"
                label="Repayment Date"
                control={control}
                class="mb-0"
                iProps={{ size: 'large' }}
                initValue=""
                isRequired={true}
                rules={{
                  required: 'Date is required.',
                }}
                validate={errors.date && 'error'}
                validMessage={errors.date && errors.date.message}
              />
            </Col>

            <Col span={24}>
              <SelectField
                isRequired={true}
                fieldname="purpose_code"
                label="Purpose Code"
                control={control}
                initValue=""
                iProps={{
                  size: 'large',
                  placeholder: 'Please select',
                  isMulti: true,
                }}
                rules={{
                  required: 'Purpose Code is required.',
                }}
                onChange={(e) => purposeSelection(e)}
                selectOption={EXPENDITURE_PURPOSE_CODE}
                validate={errors.purpose_code && 'error'}
                validMessage={errors.purpose_code && errors.purpose_code.message}
              />
            </Col>

            {purposeCode && (
              <Col span={24}>
                <InputField
                  isRequired={true}
                  fieldname="remarks"
                  label="Required Remarks"
                  control={control}
                  initValue=""
                  iProps={{
                    size: 'large',
                  }}
                  rules={{
                    required: 'Required Remarks is required.',
                  }}
                  validate={errors.remarks && 'error'}
                  validMessage={errors.remarks && errors.remarks.message}
                />
              </Col>
            )}

            <Col span={24}>
              <TextAreaField
                fieldname="comments"
                label="Comments"
                control={control}
                initValue=""
                iProps={{
                  size: 'large',
                }}
                optionalLabel={true}
              />
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <InputRadio
                fieldname="payment_type"
                label="Form of Payment"
                control={control}
                initValue={''}
                classField="custom-radio"
                onChange={(e) => formPayment(e)}
                options={
                  <>
                    {FORMS_OF_PAYMENTS &&
                      FORMS_OF_PAYMENTS?.map((item, index) => (
                        <Fragment key={index}>
                          <Radio.Button value={item?.value}>
                            <Image src={item?.image} preview={false} width={80} />
                            <Paragraph className="smallFont12">{item?.label}</Paragraph>
                          </Radio.Button>
                        </Fragment>
                      ))}
                  </>
                }
                rules={{
                  required: 'Form of Payment is required.',
                }}
                validate={errors.payment_type && 'error'}
                validMessage={errors.payment_type && errors.payment_type.message}
              />
            </Col>

            {formOfPayment && (
              <Col span={24}>
                {formOfPayment != 'in_kind' && (
                  <Row gutter={16}>
                    {formOfPayment == 'check' && (
                      <Col span={12}>
                        <InputField
                          fieldname="check_number"
                          label="Check Number"
                          control={control}
                          initValue=""
                          optionalLabel="(Optional)"
                          iProps={{
                            size: 'large',
                          }}
                        />
                      </Col>
                    )}
                    <Col span={formOfPayment == 'check' ? 12 : 24}>
                      <SelectField
                        isRequired={true}
                        fieldname="account"
                        label="Account"
                        control={control}
                        class="mb-0"
                        iProps={{ placeholder: 'Please select' }}
                        rules={{ required: 'Account is required.' }}
                        initValue=""
                        selectOption={receiptFormData?.accounts}
                        validate={errors.account && 'error'}
                        validMessage={errors.account && errors.account.message}
                      />
                    </Col>
                  </Row>
                )}

                {formOfPayment == 'in_kind' && (
                  <Col span={24}>
                    <InputField
                      isRequired={true}
                      fieldname="in_kind_description"
                      label="In-Kind Description"
                      control={control}
                      initValue=""
                      iProps={{
                        size: 'large',
                      }}
                      rules={{
                        required: 'In-Kind Description is required.',
                      }}
                      validate={errors.in_kind_description && 'error'}
                      validMessage={errors.in_kind_description && errors.in_kind_description.message}
                    />
                  </Col>
                )}
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};
